import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import Vuetify from "vuetify";
import Vue from "vue";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import { NavigationGuardNext } from "vue-router";
import { GROUP_TYPE_CONSTANT } from "@/modules/WebViews/GroupTypeService/constants/GroupTypeConstant";
import {
  ERROR_SESSION,
  PROFILE_CONSTANTS
} from "@/modules/Profile/constants/ProfileConstants";
import { SessionService } from "@/modules/Sessions/services/SessionService";
import { Http } from "@status/codes";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { Session } from "@/modules/Profile/models/Session";
import SessionVisualizationProgress from "../../SessionVisualizationProgress/SessionVisualizationProgress.vue";
import { SESSIONS_STATES } from "@/modules/Sessions/constants/SessionsConstants";
import { STORE_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { mapGetters } from "vuex";
import store from "@/store";
import ShowIcon from "@/shared/components/ShowIcon/ShowIcon.vue";
Vue.use(Vuetify);

@Component({
  name: "GroupServiceFill",
  components: {
    ModalTemplate,
    SessionVisualizationProgress,
    ShowIcon
  },
  computed: {
    ...mapGetters({
      refreshGroupService: "getGroupServiceRefresh"
    })
  }
})
export default class GroupServiceFill extends Vue {
  @Inject() sessionService!: SessionService;

  @Prop() private listToDisplay!: object;
  @Prop() private itemsByStep?: boolean;
  @Prop() private playbook!: string;
  @Prop() private forms!: string[];

  nextFunction!: NavigationGuardNext | null;

  cardClass = STYLE_CLASSES.CARD;

  refreshGroupService!: boolean;
  modalConfirmationText = GROUP_TYPE_CONSTANT.DIALOG_MESSAGES.EXIT_TEXT;
  modalConfirmationTitle = GROUP_TYPE_CONSTANT.DIALOG_MESSAGES.EXIT_TITLE;
  dialogConfirmation = false;

  stepperModel = -1;
  openPanel: number[] = [];
  openedTemplate = 0;
  openedCluster = 0;

  lastId = "";
  lastPlaybook = "";
  lastItemTemplate = "";
  lastGroup = "";
  lastIndexTemplate = 0;
  lastIndexContent = 0;
  session: Session = new Session();
  sessions: Session[] = [];
  loadSession = false;
  showPlaybook = true;
  SESSIONS_STATES = SESSIONS_STATES;

  @Watch("listToDisplay")
  setStep() {
    this.stepperModel = -1;
    this.openedTemplate = -1;
    this.$nextTick(() => {
      this.stepperModel = 0;
    });
  }
  @Watch("refreshGroupService")
  async refreshGroup() {
    this.openedTemplate = 0;
    await this.emitOperation(
      this.lastId,
      this.lastPlaybook,
      this.lastItemTemplate,
      this.lastGroup,
      0,
      0
    );
    store.commit(STORE_CONSTANTS.REFRESH_GROUP_SERVICE, false);
  }

  async emitOperation(
    id: string,
    playbook: string,
    itemTemplateId: string,
    groupId: string,
    indexTemplate: number,
    indexContent: number
  ) {
    this.session = new Session();

    if (id) {
      this.getSessionById(id);
    } else {
      this.showPlaybook = true;
    }

    this.lastId = id;
    this.lastPlaybook = playbook;
    this.lastItemTemplate = itemTemplateId;
    this.lastGroup = groupId;
    this.lastIndexTemplate = indexTemplate;
    this.lastIndexContent = indexContent;

    if (this.playbook === "") {
      this.openedTemplate = indexTemplate;
      this.openedCluster = indexContent;
    } else if (
      indexTemplate == this.openedTemplate &&
      indexContent == this.openedCluster
    ) {
      return;
    } else if (this.forms.length > 0) {
      this.dialogConfirmation = true;
      return;
    } else {
      this.openedTemplate = indexTemplate;
      this.openedCluster = indexContent;
      this.openPanel = [indexTemplate];
    }
    this.$emit(
      PROFILE_CONSTANTS.EMIT_OPERATIONS.HANDLE_OPERATION,
      id,
      playbook,
      itemTemplateId,
      groupId
    );
  }

  handleModalAccept() {
    this.dialogConfirmation = false;
    this.openedTemplate = this.lastIndexTemplate;
    this.openedCluster = this.lastIndexContent;
    this.openPanel = [this.lastIndexTemplate];
    this.$emit(
      PROFILE_CONSTANTS.EMIT_OPERATIONS.HANDLE_OPERATION,
      this.lastId,
      this.lastPlaybook,
      this.lastItemTemplate,
      this.lastGroup
    );

    if (this.nextFunction) {
      this.nextFunction();
      this.nextFunction = null;
    }
  }

  handleModalCancel() {
    this.dialogConfirmation = false;
    if (this.nextFunction) {
      this.nextFunction(false);
      this.nextFunction = null;
    }
  }

  prepareToExit(next: NavigationGuardNext) {
    this.nextFunction = next;

    if (this.forms.length > 0) {
      this.dialogConfirmation = true;
      return;
    } else {
      next();
    }
  }

  async getSessionById(sessionId: string) {
    try {
      this.loadSession = true;
      const session = this.sessions.find(session => session.id === sessionId);
      if (session) {
        this.session = session;
        this.loadSession = false;
        this.showPlaybook =
          session.state === SESSIONS_STATES.ASIGNED ? true : false;
        return;
      }

      const responseSession = await this.sessionService.getSessionById(
        sessionId
      );
      if (responseSession.code !== Http.Found) {
        Snackbar.popError(responseSession.message);
        this.loadSession = false;
        this.showPlaybook = false;
        return;
      }

      if (
        responseSession.data?.state === SESSIONS_STATES.COMPLETE ||
        responseSession.data?.state === SESSIONS_STATES.IN_PROGRESS ||
        responseSession.data?.state === SESSIONS_STATES.CANCELLED
      ) {
        this.session = responseSession.data!;
        this.sessions.push(responseSession.data!);
        this.showPlaybook = false;
      } else {
        this.session = new Session();
        this.session.state = "";
        this.showPlaybook = true;
      }
      this.loadSession = false;
    } catch (error) {
      Snackbar.popError(ERROR_SESSION);
      return undefined;
    }
  }

  restartSession(sessionId: string) {
    const session = this.sessions.find(session => session.id === sessionId);
    session!.state = SESSIONS_STATES.ASIGNED;
    this.showPlaybook = true;
  }
}
